import React from "react";
import InvoicePill from "../components/InvoicePill";

// Work billed separately from the retainer or block (a workshop, an extra
// session, a Fresh Eyes phase) moves through three states. Click the pill to
// advance it; the item's `status` is the stored fact.
export const BILLED_STATUSES = ["to-invoice", "invoiced", "paid"];
export const billedStatus = item => BILLED_STATUSES.includes(item?.status) ? item.status : "to-invoice";
export const nextBilledStatus = s => BILLED_STATUSES[(BILLED_STATUSES.indexOf(billedStatus({ status: s })) + 1) % BILLED_STATUSES.length];
const PILL = { "to-invoice": "pending", invoiced: "invoiced", paid: "paid" };

export default function BilledStatusPill({ item, onCycle }) {
  const s = billedStatus(item);
  const next = nextBilledStatus(s);
  return (
    <span onClick={onCycle ? () => onCycle(next) : undefined} title={onCycle ? `Mark as ${next.replace("-", " ")}` : undefined} style={{ cursor: onCycle ? "pointer" : "default", display: "inline-flex" }}>
      <InvoicePill invoice={PILL[s]} />
    </span>
  );
}
